import script from "./detectNotch.vue?vue&type=script&lang=js"
export * from "./detectNotch.vue?vue&type=script&lang=js"

import "./detectNotch.vue?vue&type=style&index=0&id=4f9f6ede&lang=css"

const __exports__ = script;

export default __exports__